'use client';

import { X } from 'lucide-react';
import Image from 'next/image';

import { Dialog, DialogContent, DialogHeader } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

interface DonationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  authorName: string;
}

const getInitials = (name: string) => {
  if (!name || typeof name !== 'string') return '?';
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const DonationSuccessModal = ({
  isOpen,
  onClose,
  authorName,
}: DonationSuccessModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        hideCloseButton
        className="sm:max-w-[500px] rounded-2xl p-6 bg-white flex flex-col gap-6"
      >
        <DialogHeader className="relative flex items-center justify-center space-y-0">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-0 top-0 bg-[#E6E6E6] rounded-[7.5px] p-[9px] hover:opacity-80 transition-opacity"
          >
            <X className="h-3 w-3" />
          </button>
        </DialogHeader>

        <div className="flex justify-center">
          <Image
            src="/images/donut-modal/thanks-for-donut.png"
            alt="Спасибо за донат"
            width={490}
            height={200}
            className="w-[490px] h-[200px] object-contain"
          />
        </div>

        <div className="text-center">
          <h2 className="text-2xl font-black text-[#1B1D22] uppercase leading-none">СПАСИБО!</h2>
          <div className="text-2xl font-black text-[#1B1D22] uppercase leading-none">
            ДОНАТ ОТПРАВЛЕН
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 bg-[#F2F3F7] max-w-fit mx-auto rounded-[80px] px-4 py-2">
          <Avatar isSquare className="h-10 w-10 !rounded-full">
            <AvatarFallback
              isSquare
              className="bg-[#E8E9ED] text-[#1B1D22] text-sm font-medium !rounded-full"
            >
              {getInitials(authorName)}
            </AvatarFallback>
          </Avatar>
          <span className="text-base font-medium text-[#1B1D22]">{authorName}</span>
        </div>

        <div className="flex justify-center">
          <Button
            onClick={onClose}
            className="w-full h-[46px] max-w-[280px] bg-[#505CFF] hover:bg-[#505CFF]/90 text-white text-sm font-normal rounded-[12px]"
          >
            Отлично
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
